export default __webpack_public_path__ + "static/media/jacket.dce34fd9.png";